import React, { useState } from "react";
import { QrReader } from "react-qr-reader";
import { Modal, Button, Spinner } from "react-bootstrap";

const MeetingQRScanner = ({ show, onJoin, onClose }) => {
  const [scanned, setScanned] = useState(false);
  const [result, setResult] = useState("");
  const [loading, setLoading] = useState(true);

  return (
    <Modal
      show={show}
      onHide={onClose}
      centered
      size="md"
      backdrop="static"
      keyboard={true}
    >
      <Modal.Header closeButton>
        <Modal.Title>Scan Meeting QR Code</Modal.Title>
      </Modal.Header>

      <Modal.Body >
        <p style={{ fontSize: 12, color: "#555" }}>
          Align the QR code inside the camera view.
        </p>
        {loading && (
          <div style={{ textAlign: "center", margin: "20px 0" }}>
            <Spinner animation="border" variant="primary" />
            <p style={{ marginTop: 10 }}>Starting camera...</p>
          </div>
        )}

        <div style={{ display: loading ? "none" : "block" }}>
          <QrReader
            constraints={{ video: { facingMode: "environment" } }}
            scanDelay={500}
            onResult={(res) => {
              if (loading) setLoading(false); 

              if (res?.text && !scanned) {
                
                setScanned(true);
                setResult(res.text);
                console.log("Scanned QR:", res.text);
                onJoin(res.text);
              }
            }}
            containerStyle={{ width: "100%" }}
            videoStyle={{ width: "100%", height: "auto", borderRadius: "8px" }}
          />
        </div>
      </Modal.Body>
    </Modal>
  );
};

export default MeetingQRScanner;

// import React, { useState, useRef } from "react";
// import { QrReader } from "react-qr-reader";
// import { Modal, Button, Spinner } from "react-bootstrap";
// import jsQR from "jsqr";

// const MeetingQRScanner = ({ show, onJoin, onClose }) => {
//   const [scanned, setScanned] = useState(false);
//   const [loading, setLoading] = useState(true);
//   const fileRef = useRef();

//   const handleFileScan = (e) => {
//     const file = e.target.files[0];
//     if (!file) return;

//     const img = new Image();
//     const reader = new FileReader();

//     reader.onload = () => {
//       img.src = reader.result;
//     };

//     img.onload = () => {
//       const canvas = document.createElement("canvas");
//       const ctx = canvas.getContext("2d");

//       canvas.width = img.width;
//       canvas.height = img.height;

//       ctx.drawImage(img, 0, 0, img.width, img.height);

//       const imageData = ctx.getImageData(
//         0,
//         0,
//         canvas.width,
//         canvas.height
//       );

//       const code = jsQR(imageData.data, canvas.width, canvas.height);

//       if (code) {
//         console.log("QR From Image:", code.data);
//         setScanned(true);
//         onJoin(code.data);
//       } else {
//         alert("No QR code found in image");
//       }
//     };

//     reader.readAsDataURL(file);
//   };

//   return (
//     <Modal
//       show={show}
//       onHide={onClose}
//       centered
//       size="md"
//       backdrop="static"
//       keyboard={true}
//     >
//       <Modal.Header closeButton>
//         <Modal.Title>Scan Meeting QR Code</Modal.Title>
//       </Modal.Header>

//       <Modal.Body>
//         <p style={{ fontSize: 12, color: "#555" }}>
//           Align the QR code inside the camera view.
//         </p>

//         {loading && (
//           <div style={{ textAlign: "center", margin: "20px 0" }}>
//             <Spinner animation="border" variant="primary" />
//             <p style={{ marginTop: 10 }}>Starting camera...</p>
//           </div>
//         )}

//         <div style={{ display: loading ? "none" : "block" }}>
//           <QrReader
//             constraints={{ video: { facingMode: "environment" } }}
//             scanDelay={500}
//             onResult={(res) => {
//               if (loading) setLoading(false);

//               if (res?.text && !scanned) {
//                 setScanned(true);
//                 console.log("Scanned QR:", res.text);
//                 onJoin(res.text);
//               }
//             }}
//             containerStyle={{ width: "100%" }}
//             videoStyle={{
//               width: "100%",
//               height: "auto",
//               borderRadius: "8px",
//             }}
//           />
//         </div>

//         <div style={{ textAlign: "center", marginTop: 15 }}>
//           <input
//             type="file"
//             accept="image/*"
//             ref={fileRef}
//             style={{ display: "none" }}
//             onChange={handleFileScan}
//           />

//           <Button
//             variant="secondary"
//             onClick={() => fileRef.current.click()}
//           >
//             Upload QR from Gallery
//           </Button>
//         </div>
//       </Modal.Body>
//     </Modal>
//   );
// }

// export default MeetingQRScanner;